// @flow

import * as React from 'react';
import styled from '@emotion/styled';

import LoginFormLayout from './layouts/LoginForm.layout';
import { DesktopView, MobileView } from '../../config/mediaQuery';

const CenteredContent = styled('div')`
  display: flex;
  width: 100vw;
  height: 100vh;
  align-items: center;
  justify-content: center;
`;

class App extends React.Component<{}> {
  render() {
    return (
      <>
        <DesktopView>
          <CenteredContent>
            <LoginFormLayout />
          </CenteredContent>
        </DesktopView>
        <MobileView>
            <div className='mobile-login'> 
              <h1>Polaner Sales Portal</h1>
            </div>
            <LoginFormLayout/>
        </MobileView>
      </>
    );
  }
}

export default App;
